import { render, staticRenderFns } from "./MagicSortingModal.vue?vue&type=template&id=1a667b7a&"
import script from "./MagicSortingModal.vue?vue&type=script&lang=ts&"
export * from "./MagicSortingModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports